import { render, staticRenderFns } from "./map-block.vue?vue&type=template&id=5b7401ba&scoped=true"
import script from "./map-block.vue?vue&type=script&lang=ts"
export * from "./map-block.vue?vue&type=script&lang=ts"
import style0 from "./map-block.vue?vue&type=style&index=0&id=5b7401ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7401ba",
  null
  
)

export default component.exports